<template>
  <div class="api-webhooks-tab">
    <ApiTabEmptyState
      title="No webhooks yet"
      description="Send Crossbeam signals to your own systems as they happen. Create a webhook to choose the events and the destination."
      create-cta-text="Create webhook"
      :icon="['fak', 'share']"
    />
  </div>
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue';

import ApiTabEmptyState from '../components/ApiTabEmptyState.vue';

useHead({ title: 'Webhooks - API - Crossbeam' });
</script>
